module.exports = __webpack_public_path__ + "static/media/antigua-beaches-11.5714ac59.jpg";